(function(angular) {
    'use strict';

    angular.module('aprima-legacy-common').factory('SecurityRepository', [
        '$q',
        'PermissionService',
        SecurityRepository
    ]);

    function SecurityRepository(
        $q,
        PermissionService
    ) {
        var service = {
            getPermissions: getPermissions
        };

        return service;

        function getPermissions(permissionName) {
            var promise = PermissionService.getPermissionsJs(permissionName);
            return $q.when(promise);
        }
    }

})(window.angular);
